import { AuditsQueryVariables } from '@optools/services/operator-gateway/types/generated/graphql';
import { endOfDay, startOfDay } from 'date-fns';
import { TZDate } from 'react-day-picker';
import { z } from 'zod';

export const auditSchema = z.object({
  email: z.string().optional(),
  endDate: z
    .string()
    .nullable()
    .default(() => endOfDay(new TZDate()).toISOString()),
  instigator: z.string().optional(),
  limit: z.number().optional().default(25),
  operations: z.array(z.string()).optional(),
  page: z.number().optional().default(0),
  sourceSystems: z.array(z.string()).optional(),
  startDate: z
    .string()
    .nullable()
    .default(() => startOfDay(new TZDate()).toISOString()),
  tag: z.object({ name: z.string(), value: z.string() }).optional(),
  traceId: z.string().optional(),
}) satisfies z.ZodObject<Record<keyof AuditsQueryVariables, z.ZodTypeAny>>;

export type AuditSchemaValues = z.infer<typeof auditSchema>;

export type AuditFilters = Omit<AuditSchemaValues, 'page' | 'limit'>;

export const enum AuditTableDialogType {
  EventData = 'eventData',
  ResourceTags = 'resourceTags',
}

export const auditSearchParamsSchema = auditSchema.extend({
  auditId: z.number().optional(),
  dialog: z.enum([AuditTableDialogType.EventData, AuditTableDialogType.ResourceTags]).optional(),
});
